import { render, staticRenderFns } from "./ContactManager.vue?vue&type=template&id=4e32adfc&scoped=true&"
import script from "./ContactManager.vue?vue&type=script&lang=js&"
export * from "./ContactManager.vue?vue&type=script&lang=js&"
import style0 from "./ContactManager.vue?vue&type=style&index=0&id=4e32adfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e32adfc",
  null
  
)

export default component.exports